import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { blogCategories, blogPosts } from '../data/site.js';

export default function BlogPage() {
  const [active, setActive] = useState('all');
  const visiblePosts = useMemo(() => (active === 'all' ? blogPosts : blogPosts.filter((post) => post.categorySlug === active)), [active]);
  const featured = blogPosts[0];
  const featuredImage = featured.image || '/images/hero-clinic.png';
  const featuredImageAlt = featured.imageAlt || `${featured.title} illustration`;

  return (
    <>
      <section className="blog-page-hero">
        <div className="container blog-page-hero__inner">
          <div className="blog-page-hero__content">
            <p className="caption">My Dentist Blog</p>
            <h1 className="heading-display">Dental information Varanasi patients can actually use.</h1>
            <p className="text-body">Clear explanations of symptoms, treatment choices, prevention and what to expect, written to help patients in Varanasi ask better questions before they book.</p>
            <p className="blog-page-hero__note">These guides can help you prepare, but they cannot diagnose your mouth online.</p>
          </div>
          <div className="blog-page-hero__image">
            <img src={featuredImage} alt={featuredImageAlt} loading="eager" />
          </div>
        </div>
      </section>

      <section className="blog-filter-bar" aria-label="Filter blog articles">
        <div className="container blog-filter-bar__inner">
          <div className="blog-filters">
            {blogCategories.map((category) => (
              <button key={category.value} type="button" className={`blog-filter ${active === category.value ? 'is-active' : ''}`} aria-pressed={active === category.value} onClick={() => setActive(category.value)}>
                {category.label}
              </button>
            ))}
          </div>
          <p className="blog-filter-count"><span>{visiblePosts.length}</span> articles</p>
        </div>
      </section>

      {active === 'all' || featured.categorySlug === active ? (
        <section className="blog-featured-section" id="featured">
          <div className="container">
            <article className="blog-featured">
              <div className="blog-featured__visual blog-featured__visual--image">
                <span>Featured</span>
                <img src={featuredImage} alt={featuredImageAlt} loading="lazy" />
                <small>{featured.category}</small>
              </div>
              <div className="blog-featured__content">
                <span className="caption">Editor's starting point</span>
                <h2 className="heading-1"><Link to={`/blog/${featured.slug}/`}>{featured.title}</Link></h2>
                <p className="text-body">{featured.summary}</p>
                <div className="blog-card__meta"><span>{featured.readTime}</span><span>Clinically reviewed</span></div>
              </div>
            </article>
          </div>
        </section>
      ) : null}

      <section className="blog-directory-section">
        <div className="container">
          <div className="blog-directory-heading">
            <div>
              <p className="caption">Browse the library</p>
              <h2 className="heading-2">All articles</h2>
            </div>
            <p className="text-body">Use the categories to narrow the list. Each guide includes a short answer, practical guidance, local context and a clear reminder to book an assessment when symptoms need attention.</p>
          </div>
          <div className="blog-directory">
            {visiblePosts.map((post, index) => (
              <article className="blog-card" key={post.slug}>
                <div className="blog-card__index">{String(index + 1).padStart(2, '0')}</div>
                <div className="blog-card__content">
                  <span className="caption">{post.category}</span>
                  <h2><Link to={`/blog/${post.slug}/`}>{post.title}</Link></h2>
                  <p>{post.summary}</p>
                  <div className="blog-card__meta"><span>{post.readTime}</span><span>Updated {post.updated}</span></div>
                </div>
              </article>
            ))}
          </div>
          {visiblePosts.length === 0 ? <p className="blog-no-results">No articles are available in this category yet.</p> : null}
        </div>
      </section>

      <section className="blog-cta">
        <div className="container blog-cta__inner">
          <div>
            <p className="caption">Need advice about your own teeth?</p>
            <h2 className="heading-2">An article cannot diagnose a dental problem.</h2>
          </div>
          <div>
            <p className="text-body">Arrange an assessment for advice based on your health, symptoms and treatment priorities.</p>
            <Link to="/#booking" className="btn btn--primary">Book an appointment</Link>
          </div>
        </div>
      </section>
    </>
  );
}
